import { useState, useEffect } from "react";

export interface LiveEvent {
  id: number;
  username: string;
  city: string;
  country: string;
  suspect: string;
  correct: boolean;
  secondsAgo: number;
}

const CITIES = [
  { city: "Lagos", country: "Nigeria" },
  { city: "London", country: "UK" },
  { city: "New York", country: "US" },
  { city: "São Paulo", country: "Brazil" },
  { city: "Toronto", country: "Canada" },
  { city: "Nairobi", country: "Kenya" },
  { city: "Sydney", country: "Australia" },
  { city: "Berlin", country: "Germany" },
  { city: "Manila", country: "Philippines" },
  { city: "Dubai", country: "UAE" },
  { city: "Mumbai", country: "India" },
  { city: "Paris", country: "France" },
  { city: "Accra", country: "Ghana" },
  { city: "Chicago", country: "US" },
  { city: "Amsterdam", country: "Netherlands" },
  { city: "Singapore", country: "Singapore" },
  { city: "Johannesburg", country: "South Africa" },
  { city: "Mexico City", country: "Mexico" },
  { city: "Seoul", country: "South Korea" },
  { city: "Cairo", country: "Egypt" },
];

const USERNAMES = [
  "shadow_reader", "cold_case_k", "nightowl_77", "detective_felix",
  "the_analyst", "truth_seeker", "mrs_marple", "inkblot_9",
  "clue_hunter", "the_watcher", "silent_wit", "case_closed",
  "fog_light", "reader_28", "sharp_mind", "dark_horse_d",
  "third_eye", "logic_bird", "keen_eye_q", "vault_breaker",
];

const SUSPECTS_LIST = ["Adrian", "Victor", "Marcus"];

function generateEvent(id: number): LiveEvent {
  const location = CITIES[Math.floor(Math.random() * CITIES.length)];
  const username = USERNAMES[Math.floor(Math.random() * USERNAMES.length)];
  const suspect = SUSPECTS_LIST[Math.floor(Math.random() * SUSPECTS_LIST.length)];
  const correct = suspect === "Victor";

  return {
    id,
    username,
    city: location.city,
    country: location.country,
    suspect,
    correct,
    secondsAgo: Math.floor(Math.random() * 45),
  };
}

function generateInitialEvents(): LiveEvent[] {
  return Array.from({ length: 8 }, (_, i) => ({
    ...generateEvent(i),
    secondsAgo: (i + 1) * 12,
  }));
}

export function useLiveActivity() {
  const [activeCount, setActiveCount] = useState(43);
  const [events, setEvents] = useState<LiveEvent[]>(generateInitialEvents);

  // Fluctuate active count
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveCount((prev) => {
        const delta = Math.floor(Math.random() * 5) - 2;
        return Math.max(28, Math.min(80, prev + delta));
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Age existing events
  useEffect(() => {
    const interval = setInterval(() => {
      setEvents((prev) =>
        prev.map((e) => ({ ...e, secondsAgo: e.secondsAgo + 4 }))
      );
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // Add new events
  useEffect(() => {
    const interval = setInterval(() => {
      const delay = 4000 + Math.random() * 6000;
      setTimeout(() => {
        setEvents((prevEvents) => {
          const newId = prevEvents.length + Date.now();
          return [
            { ...generateEvent(newId), secondsAgo: 0 },
            ...prevEvents.slice(0, 9),
          ];
        });
      }, delay);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return { activeCount, events };
}
